import qs from 'qs';
import { axiosAPI } from '@/axios';

const loadSchedulesByMonth = () => {
  return axiosAPI.get('/daily-schedules');
};

const loadDailySchedulesByDate = (scheduleYear, scheduleMonth, scheduleDate) => {
  return axiosAPI.get(`/daily-schedules/${scheduleYear}/${scheduleMonth}/${scheduleDate}?includes=items`);
};

const updateDailySchedulesById = (scheduleId, payload) => {
  return axiosAPI.put(`/daily-schedules/${scheduleId}`, payload);
};

const loadSchedulesMonthly = (scheduleYear, scheduleMonth) => {
  return axiosAPI.get(`/daily-schedules/${scheduleYear}/${scheduleMonth}`);
};

const loadSchedulesSuggestByDate = (filter) => {
  const query = qs.stringify(filter, { addQueryPrefix: true, skipNulls: true });
  if (query) {
    return axiosAPI.get(`/scheduleitems-suggest${query}`);
  }
  return axiosAPI.get('/scheduleitems-suggest');
};

const loadSchedulesByEpisode = (filter) => {
  const query = qs.stringify(filter, { addQueryPrefix: true, skipNulls: true });
  if (query) {
    return axiosAPI.get(`/scheduleitems${query}`);
  }
  return axiosAPI.get('/scheduleitems');
};

const createScheduleDaily = (payload) => {
  return axiosAPI.post('/daily-schedules', payload);
};

const deleteDailySchedulesById = (scheduleId) => {
  return axiosAPI.delete(`/daily-schedules/${scheduleId}`);
};

export {
  loadSchedulesByMonth,
  loadDailySchedulesByDate,
  updateDailySchedulesById,
  loadSchedulesMonthly,
  loadSchedulesSuggestByDate,
  loadSchedulesByEpisode,
  createScheduleDaily,
  deleteDailySchedulesById,
};
